import {default as BottomNavigator} from './BottomNavigator-Component';
export default BottomNavigator
